import React from 'react'
import { Switch, Route } from 'react-router-dom'
import type { FieldErrors } from 'react-hook-form'
import CompanyView from './Views/CompanyView'
import ContactFilterView from './Views/ContactFilterView'
import FormatView from './Views/FormatView'
import SaleView from './Views/SaleView'
import VehicleView from './Views/VehicleView'
import WorkflowsView from './Views/WorkflowsView'
import type { DashboardCardConfig } from './types'

enum ErrorToPathsEnum {
    format = '*',

    company = '/company',
    contact = '/contact',
    hasWords = '/vehicle',
    vehicle = '/vehicle',
    sale = '/sale',
    workflows = '/workflows',
}

export type ErrorKey = keyof typeof ErrorToPathsEnum
export type Paths = `${ErrorToPathsEnum}`

export const errorToRoute = (errors: FieldErrors<DashboardCardConfig>): Paths | undefined => {
    if (errors.format) {
        return ErrorToPathsEnum.format
    }

    if (errors.filters) {
        const keys = Object.keys(errors.filters) as ErrorKey[]
        const match = keys.find((k) => ErrorToPathsEnum[k])

        if (match) {
            return ErrorToPathsEnum[match]
        }
    }

    return undefined
}

export const TabViewer: React.VFC = () => {
    return (
        <Switch>
            <Route path="/vehicle" component={VehicleView} />
            <Route path="/sale" component={SaleView} />
            <Route path="/company" component={CompanyView} />
            <Route path="/contact" component={ContactFilterView} />
            <Route path="/workflows" component={WorkflowsView} />
            <Route path="*" component={FormatView} />
        </Switch>
    )
}

export default TabViewer
